import type { FaireBrandEntity } from "../../entity_types/brand";

export const moma_pozzi: FaireBrandEntity = {
  token: "moma-pozzi",
  type: "brand",
  name: "Pozzi Milano",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/77ad786c6a8e785ccb39be74a705cd1753326af0f2a15f1d8c43cccd9f4d8e83.webp",
  minimumOrderDollars: 100,
  rating: 4.8,
  location: "Milan, Italy",
  tags: ["tableware", "drinkware", "design"],
  categoryTokens: ["cat_accents-all"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
